module.exports = __webpack_public_path__ + "img/page2-bg.9747ff05.png";